import { render } from "./DataBase.vue?vue&type=template&id=27269338&scoped=true"
import script from "./DataBase.vue?vue&type=script&lang=js"
export * from "./DataBase.vue?vue&type=script&lang=js"

import "./DataBase.vue?vue&type=style&index=0&id=27269338&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27269338"

export default script